import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriesAndTagsDisplayComponent } from '@app/common/categories-and-tags-display/categories-and-tags-display.component';
import { ScoreItem } from '../score-item.model';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-shadow-item',
  templateUrl: './shadow-item.component.html',
  styleUrls: ['./shadow-item.component.scss'],
  standalone: true,
  imports: [CommonModule, CategoriesAndTagsDisplayComponent, AngularSvgIconModule],
})
export class ShadowItemComponent {
  @Input() item!: ScoreItem;
  @Input() showDeleteIcon = true;
  @Output() delete = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
}
